import React from 'react'
import PropTypes from 'prop-types'
import Card from '../Card/Card'
import Hero from '../Hero/Hero'
import convert from 'shared/units/convert'
import styles from '../Card/_card.css'

import icons from './personalIcons'
import backgrounds from './personalBackgrounds'

function PersonalYearInReview (props) {
  const {
    activateStatCard,
    activeCards,
    userCountry,
    userUnitPreference,
    userYear,
    username,
    year,
  } = props

  const isImperial = userUnitPreference === 'imperial'

  const totalSeconds = userYear.all.total_duration ? userYear.all.total_duration.value : null
  const totalDuration = totalSeconds ? {
    hours: convert(totalSeconds).from('second').to('hour'),
    days: parseInt(convert(totalSeconds).from('second').to('day'), 10),
  } : null

  const totalMeters = userYear.all.total_distance ? userYear.all.total_distance.value : null
  const totalDistance = totalMeters ? {
    miles: convert(totalMeters).from('meter').to('mile'),
    km: totalMeters / 1000,
    fiveK: parseInt(totalMeters / 5000, 10),
  } : null

  const totalWorkouts = userYear.all.total_workouts ? {
    count: userYear.all.total_workouts.value,
    weeks: parseInt(userYear.all.total_workouts.value / 7, 10),
  } : null

  const totalJoules = userYear.all.total_energy_expended ? userYear.all.total_energy_expended.value : null
  const totalCalories = convert(totalJoules).from('joules').to('kilocalorie')
  const totalEnergy = totalJoules ? {
    calories: totalCalories,
    pizza: parseInt(totalCalories / 370, 10),
  } : null

  const totalChallenges = userYear.challenges ? userYear.challenges.number_of_challenges : null
  const totalAwards = userYear.challenges ? userYear.challenges.number_of_awards : null

  return (
    <div className={styles.personalCards}>
      <Hero
        activateStatCard={activateStatCard}
        activeCards={activeCards}
        id='personal-hero'
        isLoggedIn={true}
        location='personal'
        showProfileImage={true}
        userCountry={userCountry}
        username={username}
        year={year}
      />
      { totalDistance ?
        <Card
          activateStatCard={activateStatCard}
          activeCards={activeCards}
          username={username}
          id={isImperial ? 'personalDistanceImperial' : 'personalDistanceMetric'}
          background={ backgrounds.distance }
          stat={
            {
              number: isImperial ? totalDistance.miles : totalDistance.km,
              captionValue: totalDistance.fiveK,
            }
          }
          comparison={
            {
              gradient: icons.distanceGradient,
              value: totalDistance.fiveK,
            }
          }
          color='black'
          showProfileImage={true}
        />
      : null }
      { totalWorkouts ?
        <Card
          activateStatCard={activateStatCard}
          activeCards={activeCards}
          username={username}
          id='personalWorkouts'
          stat={
            {
              number: totalWorkouts.count,
              captionValue: totalWorkouts.weeks,
            }
          }
          comparison={
            {
              gradient: icons.workoutsGradient,
              light: icons.workoutsLight,
              value: totalWorkouts.weeks,
            }
          }
          color='white'
          showProfileImage={true}
        />
      : null }
      { totalDuration ?
        <Card
          activateStatCard={activateStatCard}
          activeCards={activeCards}
          username={username}
          id='personalDuration'
          background={ backgrounds.duration }
          stat={
            {
              number: totalDuration.hours,
              captionValue: totalDuration.days,
            }
          }
          comparison={
            {
              gradient: icons.durationGradient,
              value: totalDuration.days,
            }
          }
          showProfileImage={true}
        />
      : null }

      { totalEnergy ?
        <Card
          activateStatCard={activateStatCard}
          activeCards={activeCards}
          username={username}
          id='personalEnergy'
          stat={
            {
              number: totalEnergy.calories,
              captionValue: totalEnergy.pizza,
            }
          }
          comparison={
            {
              gradient: icons.energyGradient,
              light: icons.energyLight,
              value: totalEnergy.pizza,
            }
          }
          color='white'
          showProfileImage={true}
        />
      : null }
      { totalChallenges && totalAwards ?
        <Card
          activateStatCard={activateStatCard}
          activeCards={activeCards}
          username={username}
          id='personalChallenges'
          background={ backgrounds.challenges }
          stat={
            {
              number: totalChallenges,
              captionValue: totalAwards,
            }
          }
          comparison={
            {
              gradient: icons.durationGradient,
              value: totalAwards,
            }
          }
          color='white'
          showProfileImage={true}
        />
      : null }
    </div>
  )
}

PersonalYearInReview.propTypes = {
  userYear: PropTypes.object.isRequired,
  userUnitPreference: PropTypes.string,
  year: PropTypes.string,
  username: PropTypes.string,
  userCountry: PropTypes.string,
  activeCards: PropTypes.array,
  activateStatCard: PropTypes.func,
}

export default PersonalYearInReview



// WEBPACK FOOTER //
// ./src/components/yearInReview/2017/Personal/Personal.jsx